import React, { useContext, useState, useEffect } from 'react';
import Sidebar from '../../Components/Sidebar/Sidebar';
import "./Orders.css";
import { OrderContext } from '../../ContextAPI/OrderContext';
import axios from 'axios';

export default function Orders() {
    const { orders, loading, error } = useContext(OrderContext);
    const [orderId, setOrderId] = useState('');
    const [sortDate, setSortDate] = useState(false);
    const [filterStatus, setFilterStatus] = useState('');
    const [selectedStatus, setSelectedStatus] = useState({});

    useEffect(() => {
        // Initialize selectedStatus with current order statuses
        const initialStatus = {};
        orders.forEach(order => {
            initialStatus[order.order_id] = order.order_status;
        });
        setSelectedStatus(initialStatus);
    }, [orders]);

    if (loading) return <p>Loading orders...</p>;
    if (error) return <p>Error fetching orders: {error}</p>;

    const sortedOrders = [...orders].sort((a, b) => {
        if (sortDate) {
            return new Date(a.timestamp) - new Date(b.timestamp);
        } else {
            return new Date(b.timestamp) - new Date(a.timestamp);
        }
    });

    const filteredOrders = sortedOrders.filter(order => {
        if (filterStatus) {
            return order.order_status === filterStatus;
        }
        return true;
    });

    const searchedOrders = filteredOrders.filter(order => {
        if (orderId) {
            const user = order.user;
            const searchTerm = orderId.toLowerCase();
            return order.order_id.toString().includes(searchTerm) ||
                user?.name.toLowerCase().includes(searchTerm) ||
                user?.email.toLowerCase().includes(searchTerm) ||
                user?.mobile.toString().includes(searchTerm);
        }
        return true;
    });

    const handleStatusChange = (orderId, newStatus) => {
        setSelectedStatus(prevState => ({
            ...prevState,
            [orderId]: newStatus,
        }));
    };

    const handleSave = async (orderId) => {
        const status = selectedStatus[orderId];

        try {
            await axios.put(`${process.env.REACT_APP_API_HOST_URL}/api/orders/change-status/${orderId}`, { status }, { withCredentials: true });
            alert('Order status updated successfully');
            window.location.reload(); // Optionally, you can refresh the orders list or update the order status locally
        } catch (error) {
            console.error('Failed to update order status:', error);
            alert('Failed to update order status');
        }
    };

    const getAllowedStatusOptions = (currentStatus) => {
        switch (currentStatus) {
            case "New":
                return ["Under Review"];
            case "Under Review":
                return ["Accepted", "Rejected"];
            case "Accepted":
            case "Rejected":
                return ["Under Review"];
            default:
                return [];
        }
    };

    return (
        <div className='order-section'>
            <Sidebar />

            <div className='order-wrapper'>
                <div className='filter-sort'>
                    <div>
                        <input
                            placeholder='Enquiry No, Name, Email or Phone'
                            name='order-id'
                            type='text'
                            value={orderId}
                            onChange={(e) => setOrderId(e.target.value)}
                        />
                    </div>
                    <div className='order-sort'>
                        <p>Sort Date
                            <span>
                                {sortDate ?
                                    <i className="fa-solid fa-arrow-up-wide-short" onClick={() => setSortDate(false)}></i> :
                                    <i className="fa-solid fa-arrow-down-wide-short" onClick={() => setSortDate(true)}></i>
                                }
                            </span>
                        </p>
                    </div>
                    <div className='order-filter'>
                        <label htmlFor="dropdown">Enquiry Filter</label>
                        <select id="dropdown" onChange={(e) => setFilterStatus(e.target.value)} value={filterStatus}>
                            <option value="">All</option>
                            <option value="New">New</option>
                            <option value="Under Review">Under Review</option>
                            <option value="Accepted">Accepted</option>
                            <option value="Rejected">Rejected</option>
                        </select>
                    </div>
                </div>

                {searchedOrders.map(order => (
                    <div key={order.order_id} className='order-container'>
                        <div className='order-content header'>
                            <p className='order-id'><b>Enquiry No:</b> <span>{order.order_id}</span></p>
                            <p className='date-time'><b>Date/Time:</b> <span>{new Date(order.timestamp).toLocaleString()}</span></p>
                            <p className={`order-status ${order.order_status.toLowerCase().replace(" ", "-")}`}>
                                <b>Enquiry Status:</b>
                                <select
                                    value={selectedStatus[order.order_id] || order.order_status}
                                    onChange={(e) => {
                                        const newStatus = e.target.value;
                                        handleStatusChange(order.order_id, newStatus);
                                    }}
                                    className={`order-status-select ${order.order_status.toLowerCase().replace(" ", "-")}`}
                                >
                                    <option value={order.order_status}>{order.order_status}</option>
                                    {getAllowedStatusOptions(order.order_status).map(status => (
                                        <option key={status} value={status}>{status}</option>
                                    ))}
                                </select>
                                {selectedStatus[order.order_id] && selectedStatus[order.order_id] !== order.order_status && (
                                    <button onClick={() => handleSave(order.order_id)}>Save</button>
                                )}
                            </p>
                        </div>

                        <div className='order-content'>
                            <p><b>Enquiry From: </b>{order.user?.name}</p>
                            <p><b>Mobile: </b>{order.user?.mobile}</p>
                            <p><b>Email: </b>{order.user?.email}</p>
                            <a href={`/orders/${order._id}`}><span>View Details</span></a>
                        </div>
                    </div>
                ))}

                <div style={{ paddingBottom: "100px" }}></div>
            </div>
        </div>
    );
}
